import { WithDefaultLayout } from '@/components/DefautLayout'
import PhilosophyCard from '@/components/PhilosophyCard';
import RegistrationButton from '@/components/RegistrationButton';
import TitleTemp from '@/components/TitleTemp';
import { Page } from '@/types/Page'
import { faChartLine, faLightbulb, faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
import React from 'react'

const Home = () => {
    return (
        <div className="relative mt-20 lg:mt-24 md:mt-12">
            <img alt="indexpict" className="w-full min-h-screen lg:min-h-0 lg:h-auto md:relative lg:relative flex bg-center mx-auto" src="/images/philosophy-bg.webp" />
            <div className="absolute inset-0 bg-gray-900 opacity-70"></div>
            <div className="absolute inset-0 flex justify-center items-center px-8">
                <div className="lg:w-1/2 justify-center px-8">
                    <div className="text-white text-center md:text-start lg:text-start">
                        <h1 className="text-xl md:text-2xl md:mt-4 font-bold mb-4 text-defaultBlue">About IIT Challenge</h1>
                        <h1 className="text-xl md:text-4xl font-bold mb-4">Indonesia Innovative Technology Challenge</h1>
                        <div className="mb-4">
                            <p className='mb-4'>Indonesia Innovative Technology (IIT) Challenge 2024 proudly presents as a national competition of software programming, robotics and internationally published papers.</p>
                            <p>IIT Challenge 2024 has collaboration with Accelist Edukasi Indonesia, Universitas Kristen Krida Wacana, World Innovative Technology Challenge, Robotic Organizing Committee Indonesia</p>
                        </div>
                        <RegistrationButton />
                    </div>
                </div>
                <div className="lg:w-1/2 flex justify-center items-center mx-auto">
                    <img alt="logo" src="/images/iit-big-logo.webp" className="hidden md:block" width={398} height={205.86} />
                </div>
            </div>
        </div>
    )
}

const iitChallenge = () => {
    return (
        <>
            <h2 className="text-2xl md:text-4xl font-semibold text-center mt-24 mb-4">IIT Challenge Philosophy</h2>
            <div className="mx-auto flex justify-center">
                <div className="w-full lg:w-1/2 flex items-start justify-start md:justify-end md:items-end lg:items-end xl:items-end lg:justify-end xl:justify-end">
                    <img
                        src="/images/sustainable-logo.webp"
                        alt="Sustainable Logo"
                        className="bg-coverflex bg-center mx-auto"
                    />
                </div>
                <div className="w-full lg:w-2/3 px-8 py-2 my-auto justify-start">
                    <div className="text-left">
                        <h1 className="text-lg md:text-2xl font-bold mb-4 md:mb-4">Empowering Innovation</h1>
                        <p className="text-base md:text-base mb-8 text-gray-400 ">The IIT Challenge was founded as an innovator in Indonesia to implement the World Innovative Technology (WIT) Challenge. The WIT Challenge is an international competition that focuses on world technological developments. The ninth WIT Challenge will be held on 2-3 November 2024 at Chonnam National University, Yeosu-si, South Korea.</p>
                        <p className="text-base md:text-base text-gray-400">The WIT and IIT Challenge aim to increase childrens creativity in providing innovative solutions to Covid-19 or sustainable development (SDGs) problems. This WIT Challenge activity will be related to the SDGs goals in questions, answers, and prototypes for each participant.</p>
                    </div>
                </div>
            </div>
        </>
    );
};


const cardPhilosophy = () => {
    return (
        <>
            <TitleTemp name='IIT Challenge Objectives' />
            <div className="max-w-screen-lg mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-8 mx-auto">
                    <PhilosophyCard title='Inovate Youth' desc='Advancing innovation and creativity in technology education of the younger generation on a global competition platform' url={faLightbulb} />
                    <PhilosophyCard title='Friendship Challenge' desc='Make a friendly competition that fosters a sense of collaboration, mutual respect, and mutual support between the participant' url={faPeopleGroup} />
                    <PhilosophyCard title='Empathy Builders' desc='Increase the empathy of younger generation in solving daily life challenges, especially the 17 United Nations Sustainable Development Goals (SDGs)' url={faChartLine} />
                </div>
            </div>

        </>
    )
}


const Render = () => {
    return (
        <div>
            {Home()}
            <div className="container mx-auto">
                {iitChallenge()}
                {cardPhilosophy()}
            </div>
        </div>
    );
}

const iitPhilosophy: Page = () => {
    return (
        <div>
            {Render()}
        </div>
    );
}

iitPhilosophy.layout = WithDefaultLayout;
export default iitPhilosophy
